<template>
  <el-card class="box-card">
    <div class="main">
      <el-form ref="searchInfo" class="global-form" :inline="true">
        <el-form-item>
          <el-select v-model="info.projectId" placeholder="请选择所属项目" filterable clearable>
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="machineTeamDate">
          <!-- <el-date-picker v-model="info.machineTeamDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择台班日期">
          </el-date-picker> -->
          <el-date-picker v-model="date" unlink-panels type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="DateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="mb10">
        <el-button type="primary" icon="el-icon-plus" @click="onAdd" v-show="$ButtonShow('YMTC_ADD_01')">新增</el-button>
      </div>
      <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData">

        <el-table-column label="项目名称" min-width="80px" show-overflow-tooltip prop="projectName">
        </el-table-column>
        <el-table-column label="台班日期" min-width="80px" show-overflow-tooltip prop="machineTeamDate">
        </el-table-column>
        <el-table-column label="台班数量" min-width="70px" show-overflow-tooltip prop="machineTeamNum">
        </el-table-column>
        <el-table-column label="台班总金额" min-width="70px" show-overflow-tooltip prop="machineTeamPrice">
        </el-table-column>
        <el-table-column label="提报人" min-width="60px" show-overflow-tooltip prop="createUserName">
        </el-table-column>
        <el-table-column label="提报时间" min-width="70px" show-overflow-tooltip prop="createTime">
        </el-table-column>
        <el-table-column label="操作" width="180px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row.machineTeamId)">查看</el-button>
            <el-button type="text" @click="onEdit(row.machineTeamId)" v-show="$ButtonShow('YMTC_EDT_01')">编辑</el-button>
            <el-button type="text" @click='onDelete(row.machineTeamId)'
              v-show="$ButtonShow('YMTC_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Add :addShow.sync="addShow" @success="loadData" :id.sync=id></Add>
      <Details :detailsShow.sync="detailsShow" :id.sync=detailsId></Details>
      <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
        @size-change="loadData"></global-pagination>
    </div>
  </el-card>
</template>

<script>
import Add from './Add.vue'
import Details from './Details.vue'
export default {
  name: 'laborManageListTeams',
  components: { Add, Details },
  data() {
    return {

      info: {
        projectId: '',
        machineTeamDate: '',
        startTime: '',
        endTime: '',
      },
      date: [],
      addShow: false,
      detailsShow: false,
      id: '',
      detailsId: '',

      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  created() {
    if (this.$route.query.projectId || this.$route.query.startTime && this.$route.query.endTime) {
      this.info.projectId = this.$route.query.projectId;
      // this.info.machineTeamDate = newVal.machineTeamDate;
      this.date = [this.$route.query.startTime, this.$route.query.endTime];
      this.info.startTime = this.$route.query.startTime;
      this.info.endTime = this.$route.query.endTime;
    }
    this.loadData()
  },
  methods: {
    onSearch() {
      this.page = 1
      this.loadData()
    },

    loadData() {
      this.loading = true
      this.$axios
        .get(
          this.$apis.laborManage.selectYhMachineTeamByPage,
          {
            ...this.info,
            page: this.page,
            size: this.size,
          }
        )
        .then((res) => {
          if (res) {
            this.total = res.total || 0
            this.tableData = res.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 新增
    onAdd() {
      console.log('新增')
      this.addShow = true
    },

    // 日期选择
    DateChange(val) {
      console.log(val);
      if (val && val.length) {
        this.info.startTime = val[0];
        this.info.endTime = val[1];
      } else {
        this.info.startTime = '';
        this.info.endTime = '';
      }
    },
    // 编辑
    onEdit(id) {
      this.id = id
      this.addShow = true
    },

    // 查看
    onDetail(id) {
      this.detailsId = id
      this.detailsShow = true
    },

    // 启用/禁用班组
    onForbidden(teamId, status) {
      let submitStatus = ''
      let description = ''
      if (status === '1') {
        submitStatus = '2'
        description = '禁用'
      } else {
        submitStatus = '1'
        description = '启用'
      }
      this.$confirm(`确认${description}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$axios.post(this.$apis.laborManage.forbiddenYhTeam, { teamId, status: submitStatus }).then(() => {
            this.$message.success('操作成功')
            this.loadData()
          }).finally(() => {
            this.loading = false
          })
        })
    },

    // 删除
    onDelete(machineTeamId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$axios.post(this.$apis.laborManage.deleteYhMachineTeam, { machineTeamId }).then(() => {
            this.$message.success('删除成功')
            this.onSearch()
          }).finally(() => {
            this.loading = false
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 0px 10px;
}

.button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
</style>
